const livechat = {
	init: (): void => {
		livechat.open();
		/*
    @ts-ignore
    LC_API.on_after_load = () => {
      console.log("Livechat - on_after_load");

      const openLiveChatButtons = document.querySelectorAll(
        ".buttonOpenLiveChat, .contactBoxes__item--chatTrigger",
      );

      openLiveChatButtons.forEach(liveChatButton => {
        console.log("liveChatButton: ", liveChatButton);

        liveChatButton.addEventListener("click", () => {
          console.log("liveChatButton - click");

          //@ts-ignore
          LiveChatWidget.call("maximize");
          //@ts-ignore
          // LC_API.open_chat_window();
        });

        liveChatButton.classList.remove("disabled");
      });
    };
    */
	},

	open: (): void => {
		const livechatBanner = document.querySelector(".open-livechat");

		if (livechatBanner != null) {
			livechatBanner.addEventListener("click", () => {
				//@ts-ignore
				// LC_API.open_chat_window();
				//@ts-ignore
				LiveChatWidget.call("maximize");
			});
		}

		const openLiveChatButtons = document.querySelectorAll(
			".buttonOpenLiveChat, .contactBoxes__item--chatTrigger",
		);

		if (openLiveChatButtons.length === 0) return;

		openLiveChatButtons.forEach((liveChatButton) => {
			liveChatButton.addEventListener("click", () => {
				//@ts-ignore
				LiveChatWidget.call("maximize");
			});
		});
	},
};

export default livechat;
